// extracted by mini-css-extract-plugin
export default {"menuItem":"games-menu_menuItem__Kqyj5"};